import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const FinancialCardsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

export const FinancialCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px 14px;
    border: 1px solid ${Variables.ThemeLight.Border2};
    background: ${Variables.ThemeLight.Background2};
    border-radius: 8px;
    flex: 1 1 0;
    min-width: 96px;
`;

export const FinancialCardTitle = styled.div`
    font-family: ${Variables.Fonts.calibre};
    font-size: 10px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const FinancialCardValue = styled.div<{ $isZero?: boolean }>`
    font-family: ${Variables.Fonts.calibre};
    font-size: 19px;
    font-weight: 600;
    line-height: 1;
    color: ${({ $isZero }) => ($isZero ? Variables.ThemeLight.TextXMild : Variables.ThemeLight.TextStrong)};
`;
